<template>
    <div class="download-wrap" @scroll="highlightNav">
        <!-- ===== 导航栏 ===== -->
        <div class="navigation-section">
            <div class="navigation">
                <div class="icon-name">
                    <div class="icon"></div>
                    <div class="name">探数蚁</div>
                </div>
                <div class="view-list">
                    <div class="view-item" data-target="desktop_jiaocai" @click="eleToView('desktop_jiaocai')">同步教学练</div>
                    <div class="view-item" data-target="desktop_tupu" @click="eleToView('desktop_tupu')">知识图谱</div>
                    <div class="view-item" data-target="desktop_topic" @click="eleToView('desktop_topic')">专题突破</div>
                    <div class="view-item" data-target="desktop_photo" @click="eleToView('desktop_photo')">拍照解题</div>
                    <div class="view-item" data-target="desktop_recommand" @click="eleToView('desktop_recommand')">个性化推荐</div>
                    <div class="view-item" data-target="desktop_zhenduan" @click="eleToView('desktop_zhenduan')">今日诊断</div>
                    <div class="view-item" data-target="desktop_draw" @click="eleToView('desktop_draw')">绘制图像</div>
                    <div class="view-item" data-target="desktop_donghua"  @click="eleToView('desktop_donghua')">动画课件</div>
                    <div class="view-item" data-target="desktop_composition" @click="eleToView('desktop_composition')">智能组卷</div>
                </div>
            </div>
        </div>

        <div class="slogan-section">
            <!-- ===== 标语 ===== -->
            <div class="slogan-wrap">
                <div class="slogan">随时随地，畅享你的提分神器！</div>
            </div>
            <div class="link-wrap" @click="$router.push('/chatSearch/exercises/' + Date.now())">
                <p>点击进入网页版</p>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <path fill="currentColor" fill-rule="evenodd"
                        d="M12.793 3.793a1 1 0 0 1 1.414 0l7.5 7.5a1 1 0 0 1 0 1.414l-7.5 7.5a1 1 0 0 1-1.414-1.414L18.586 13H3a1 1 0 1 1 0-2h15.586l-5.793-5.793a1 1 0 0 1 0-1.414"
                        clip-rule="evenodd"></path>
                </svg>
            </div>

            <!-- ===== 下载卡片 ===== -->
            <div class="download-cards">
                <div class="cards-grid">
                    <div class="card-item" v-for="(item, index) in downloadList" :key="item.id">
                        <div class="card-icon">{{ item.icon }}</div>
                        <div class="card-body">
                            <div class="card-title">{{ item.platform }}</div>
                            <div class="card-desc">{{ item.desc }}</div>

                            <!-- 安卓二维码居中 -->
                            <div v-if="item.id === 'android'" class="android-qr-center">
                                <img src="/app/apk.png" alt="扫码下载安卓App" class="qr-img-mid">
                                <span class="qr-tip">扫码下载</span>
                            </div>
                        </div>
                        <a :href="getDownloadUrl(item.filename)" target="_blank" rel="noopener noreferrer" class="download-link">
                            <div class="download-btn small-btn">
                                <span>下载</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <!-- ===== 安卓安装指南 ===== -->
            <div class="android-guide-wrapper">
                <div class="android-guide">
                    <div class="guide-toggle" @click="toggleAndroidGuide">
                        <span>{{ showAndroidGuide ? '收起' : '展开' }} 安卓安装指南</span>
                        <i class="el-icon-arrow-down" :class="{ rotated: showAndroidGuide }"></i>
                    </div>
                    <div class="guide-content" v-show="showAndroidGuide">
                        <ol>
                            <li>下载 APK 文件到您的安卓设备（手机或平板）。</li>
                            <li>打开设备上的“文件管理器”，找到下载的 <code>tanshuyi.apk</code> 文件。</li>
                            <li>点击文件进行安装，若提示“未知来源”或“禁止安装”，请前往系统设置中开启“允许安装未知来源应用”（通常位于“设置 → 安全”或“设置 → 应用”）。</li>
                            <li>安装完成后，在桌面找到“探数蚁”图标，点击即可启动。</li>
                        </ol>
                        <p class="guide-note">💡 如果安装失败，请检查 APK 文件是否完整，或尝试重新下载。</p>
                    </div>
                </div>
            </div>

            <!-- ===== 主宣传图 ===== -->
            <div class="photo-svg-wrapper">
                <img src="@/assets/image/introduce/home.svg" alt="功能介绍">
            </div>
        </div>

        <!-- ===== 功能模块 ===== -->
        <div id="desktop_jiaocai" class="desktop_jiaocai introduce-section">
            <div class="title gradient-text">教材同步教学练</div>
            <div class="desc">同步主流教材章节进度，配套"教 - 学 - 练"一体化内容，帮你逐点落实知识点，夯实课堂所学基础</div>
            <div class="img-wrap first "></div>
            <div class="img-wrap second"></div>
            <div class="img-wrap three"></div>
        </div>

        <div id="desktop_tupu" class="desktop_tupu introduce-section">
            <div class="title gradient-text">知识图谱</div>
            <div class="desc">帮你搭建完整数学知识框架，知识点脉络清晰可见，学习逻辑更顺畅</div>
            <div class="img-wrap first "></div>
            <div class="img-wrap second"></div>
        </div>

        <div id="desktop_topic" class="desktop_topic introduce-section">
            <div class="title gradient-text">专题突破</div>
            <div class="desc">按"基础 — 进阶 — 压轴"三层逻辑，拆解专题内的核心考点、易错点与解题方法。</div>
            <div class="img-wrap first "></div>
            <div class="img-wrap second"></div>
            <div class="img-wrap three"></div>
        </div>

        <div id="desktop_photo" class="desktop_photo introduce-section">
            <div class="title gradient-text">拍照解题</div>
            <div class="desc">帮你快速识别题目内容，即刻启动解题流程，从拍题到出解析，一步省去繁琐输入，效率翻倍</div>
            <div class="photo-svg-wrapper">
                <img src="@/assets/image/introduce/jieti.svg" alt="拍照解题流程">
            </div>
        </div>

        <div id="desktop_recommand" class="desktop_recommand introduce-section">
            <div class="title gradient-text">个性化推荐</div>
            <div class="desc">帮你精准捕捉题型、知识点与难度要求，智能筛选适配题目，无需反复筛选，推荐直达需求</div>
            <div class="img-wrap first "></div>
        </div>

        <div id="desktop_zhenduan" class="desktop_zhenduan introduce-section">
            <div class="title gradient-text">今日诊断</div>
            <div class="desc">帮你复盘今日学习情况，精准定位知识薄弱点，无需繁琐分析，诊断直达问题根源</div>
            <div class="img-wrap first "></div>
        </div>

        <div id="desktop_draw" class="desktop_draw introduce-section">
            <div class="title gradient-text">绘制图像</div>
            <div class="desc">帮你精准生成符合要求的函数图像，让数学可视化更简单</div>
            <div class="img-wrap first "></div>
            <div class="img-wrap second"></div>
        </div>

        <div id="desktop_donghua" class="desktop_donghua introduce-section">
            <div class="title gradient-text">动画课件</div>
            <div class="desc">帮你动态演示数学原理与解题过程，大幅提升课堂教学的生动性与效率</div>
            <div class="desc">帮你直观拆解数学重难点动画，让枯燥的知识学习变得生动有趣</div>
            <div class="animation-container vertical">
                <div class="animation-item">
                    <div v-show="animationLoading[1]" class="animation-loading">
                        <div class="loading-spinner"></div>
                        <p>加载动画课件中...</p>
                    </div>
                    <div class="animation-frame-wrapper">
                        <iframe
                            v-show="!animationLoading[1]"
                            :src="animationUrls[1]"
                            frameborder="0"
                            class="animation-frame"
                            sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-modals allow-presentation"
                            allow="fullscreen"
                            title="动画课件1 - 周期变化教案"
                            @load="onAnimationLoad(1)"
                            @error="onAnimationError(1)"
                            ref="animationFrame1"
                        ></iframe>
                        <div class="fullscreen-controls">
                            <button class="fullscreen-btn" @click="toggleFullscreen(1)" :title="fullscreenId === 1 ? '退出全屏' : '全屏显示'">
                                <svg v-if="fullscreenId === 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 0 7.5 6h4a.5.5 0 0 1 0 1h-4A2.5 2.5 0 0 1 5 4.5v-4a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5v4a2.5 2.5 0 0 1-2.5 2.5h-4a.5.5 0 0 1 0-1h4A1.5 1.5 0 0 0 10 4.5v-4a.5.5 0 0 1 .5-.5zM0 5.5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 0 6 6.5v4a.5.5 0 0 1-1 0v-4A.5.5 0 0 0 4.5 6h-4a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 1 0v4A1.5 1.5 0 0 1 4.5 11h-4a.5.5 0 0 1-.5-.5z"/>
                                </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z"/>
                                </svg>
                                <span class="fullscreen-text">{{ fullscreenId === 1 ? '退出全屏' : '全屏' }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="animation-title">周期变化教案</div>
                </div>

                <div class="animation-item">
                    <div v-show="animationLoading[2]" class="animation-loading">
                        <div class="loading-spinner"></div>
                        <p>加载动画课件中...</p>
                    </div>
                    <div class="animation-frame-wrapper">
                        <iframe
                            v-show="!animationLoading[2]"
                            :src="animationUrls[2]"
                            frameborder="0"
                            class="animation-frame"
                            sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-modals allow-presentation"
                            allow="fullscreen"
                            title="动画课件2 - 含参方程解的个数"
                            @load="onAnimationLoad(2)"
                            @error="onAnimationError(2)"
                            ref="animationFrame2"
                        ></iframe>
                        <div class="fullscreen-controls">
                            <button class="fullscreen-btn" @click="toggleFullscreen(2)" :title="fullscreenId === 2 ? '退出全屏' : '全屏显示'">
                                <svg v-if="fullscreenId === 2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 0 7.5 6h4a.5.5 0 0 1 0 1h-4A2.5 2.5 0 0 1 5 4.5v-4a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5v4a2.5 2.5 0 0 1-2.5 2.5h-4a.5.5 0 0 1 0-1h4A1.5 1.5 0 0 0 10 4.5v-4a.5.5 0 0 1 .5-.5zM0 5.5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 0 6 6.5v4a.5.5 0 0 1-1 0v-4A.5.5 0 0 0 4.5 6h-4a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 1 0v4A1.5 1.5 0 0 1 4.5 11h-4a.5.5 0 0 1-.5-.5z"/>
                                </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z"/>
                                </svg>
                                <span class="fullscreen-text">{{ fullscreenId === 2 ? '退出全屏' : '全屏' }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="animation-title">含参方程解的个数</div>
                </div>
            </div>

            <el-dialog
                title="动画课件加载失败"
                :visible.sync="animationErrorDialogVisible"
                width="400px"
                center>
                <div style="text-align: center;">
                    <p>{{ animationErrorMsg }}</p>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="animationErrorDialogVisible = false">关 闭</el-button>
                    <el-button type="primary" @click="retryLoadAnimation">重 试</el-button>
                </span>
            </el-dialog>
        </div>

        <div id="desktop_composition" class="desktop_composition card-section">
            <div class="title gradient-text">组卷智能体</div>
            <div class="desc">依托精准考点数据库，AI 智能生成符合需求的试卷，从基础题到拔高题全面覆盖 </div>
            <div class="wide-detail-list">
                <div class="card">
                    <div class="card-left">
                        <div class="card-title">智能组卷 一语生成</div>
                        <div class="card-desc">依靠智能算法，仅需一句话就能生成所需试卷，满足个性化、多样化的组卷需求。
                        </div>
                    </div><img src="@/assets/image/introduce/gen.png" class="card-img">
                </div>
                <div class="card">
                    <div class="card-left">
                        <div class="card-title">多样替换，组卷灵活</div>
                        <div class="card-desc">可选相似题替换、知识点替换、收藏本替换，换掉不满意的题目，系统智能匹配题目类型与分值，瞬间完成替换，组卷调整更省心。
                        </div>
                    </div><img src="@/assets/image/introduce/replace.png" class="card-img">
                </div>
                <div class="card">
                    <div class="card-left">
                        <div class="card-title">拖拽排序，顺序随心</div>
                        <div class="card-desc">在组卷界面直接拖拽题目至目标位置，系统精准识别需求，一键同步更新题目序号，组卷排版高效又便捷。​
                        </div>
                    </div><img src="@/assets/image/introduce/drag.png" class=" card-img">
                </div>
                <div class="card">
                    <div class="card-left">
                        <div class="card-title">指令添题，新题秒入</div>
                        <div class="card-desc">只需输入题目要求，系统快速识别并校验题目信息，一键加入组卷列表，告别手动排版繁琐，组卷扩容更高效。</div>
                    </div><img src="@/assets/image/introduce/add.png" class=" card-img">
                </div>
                <div class="card">
                    <div class="card-left">
                        <div class="card-title">点选删题，错题速清</div>
                        <div class="card-desc">遇到无需保留的题目，直接在组卷界面勾选目标题目，确认后系统一键移除，同步更新卷面结构，组卷精简一步到位，操作简单又快捷。</div>
                    </div><img src="@/assets/image/introduce/delete.png" class=" card-img">
                </div>
            </div>
            <div class="narrow-detail-list">
                <div class="card">
                    <div class="card-title">指令替换，组卷灵活</div>
                    <div class="card-desc">想更换现有题目时，选中待替换题目并输入新题知识点（或选择替换题库或直接替换），系统智能匹配题目类型与分值，瞬间完成替换，组卷调整更省心。</div>
                    <img src="@/assets/image/introduce/replace.png" class="card-img">
                </div>
                <div class="card">
                    <div class="card-title">拖拽排序，顺序随心</div>
                    <div class="card-desc">在组卷界面直接拖拽题目至目标位置，系统精准识别需求，一键同步更新题目序号，组卷排版高效又便捷。​</div><img
                        src="@/assets/image/introduce/drag.png" class="card-img">
                </div>
                <div class="card">
                    <div class="card-title">指令添题，新题秒入</div>
                    <div class="card-desc">只需输入题目内容，系统快速识别并校验题目信息，一键加入组卷列表，告别手动排版繁琐，组卷扩容更高效。</div><img
                        src="@/assets/image/introduce/add.png" class="card-img">
                </div>
                <div class="card">
                    <div class="card-title">点选删题，错题速清</div>
                    <div class="card-desc">遇到无需保留的题目，直接在组卷界面勾选目标题目，确认后系统一键移除，同步更新卷面结构，组卷精简一步到位，操作简单又快捷。</div><img
                        src="@/assets/image/introduce/delete.png" class="card-img">
                </div>
            </div>
        </div>

        <!-- ===== 下载汇总表格 ===== -->
        <div class="history-section" id="history-section">
            <el-table :data="downloadList" border>
                <el-table-column prop="platform" label="平台" width="160"></el-table-column>
                <el-table-column prop="filename" label="文件名"></el-table-column>
                <el-table-column prop="desc" label="说明"></el-table-column>
                <el-table-column label="下载">
                    <template slot-scope="scope">
                        <a :href="getDownloadUrl(scope.row.filename)" target="_blank" rel="noopener noreferrer">
                            下载文件
                        </a>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- ===== 底部 ===== -->
        <div class="slogan-wrap">
            <div class="slogan">随时随地，唤起你的桌面 AI 助手</div>
        </div>

        <div class="bottom-section">
            <div data-testid="copyright-wrap" class="copyright-wrap">
                <div class="copyright">
                    <div class="registration-link">东莞市探蚁人工智能科技有限公司</div>
                    <div class="registration-link">粤ICP备2026011271号-1</div>
                </div>
                <div class="contact-area">
                    <div class="contact-links-vertical">
                        <div class="link-item" @click="openPrivatePolicy">服务条款</div>
                        <div class="link-item" @click="openServiceItem">隐私政策</div>
                        <div class="link-item contact-email">联系我们 ✏️ tanyi@tanyi.cc</div>
                    </div>
                    <div class="qr-code-block">
                        <img src="@/assets/image/ct.png" alt="联系二维码" class="qr-code-large">
                        <span class="qr-tip-text">扫码联系</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getPrivatePolicy, getServiceItems } from "@/api/login/index"

export default {
    name: 'downloadDesk',
    data() {
        return {
            downloadList: [
                {
                    id: 'linux',
                    platform: 'Linux 安装版',
                    filename: 'tanshuyi_0.1.0_amd64.deb',
                    desc: '适配荣耀、华为Linux笔记本电脑',
                    icon: '🐧'
                },
                {
                    id: 'windows-setup',
                    platform: 'Windows 安装版',
                    filename: '探数蚁-Setup-v0.1.0.exe',
                    desc: '需安装，适合长期使用',
                    icon: '🖥️'
                },
                {
                    id: 'windows-portable',
                    platform: 'Windows 免安装版',
                    filename: '探数蚁-win-v0.1.0.zip',
                    desc: '解压，点击 探数蚁.exe 即可启动',
                    icon: '💻'
                },
                {
                    id: 'android',
                    platform: '安卓 App',
                    filename: 'tanshuyi.apk',
                    desc: '安卓手机 / 平板，适配华为',
                    icon: '📱'
                }
            ],
            animationUrls: {
                1: '/animations/周期变化教案.html',
                2: '/animations/含参方程解的个数.html'
            },
            animationLoading: { 1: true, 2: true },
            animationErrorDialogVisible: false,
            animationErrorMsg: '',
            failedAnimationId: null,
            animationTimeouts: {},
            fullscreenId: null,
            showAndroidGuide: false
        }
    },
    computed: {
        baseUrl() {
            if (process.env.NODE_ENV === 'development') {
                return '/own'
            } else {
                return ''
            }
        }
    },
    mounted() {
        Object.keys(this.animationUrls).forEach(id => {
            this.setAnimationTimeout(id)
        })
        document.addEventListener('fullscreenchange', this.handleFullscreenChange)
        document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
        document.addEventListener('mozfullscreenchange', this.handleFullscreenChange)
        document.addEventListener('MSFullscreenChange', this.handleFullscreenChange)
    },
    methods: {
        getDownloadUrl(filename) {
            if (filename === 'tanshuyi.apk') {
                return '/app/tanshuyi.apk'
            }
            return this.baseUrl + '/download/package/' + encodeURIComponent(filename)
        },

        toggleFullscreen(animationId) {
            const iframe = this.$refs[`animationFrame${animationId}`]
            if (!iframe) return
            if (this.fullscreenId === animationId) {
                this.exitFullscreen()
            } else {
                this.enterFullscreen(iframe, animationId)
            }
        },
        enterFullscreen(element, animationId) {
            if (element.requestFullscreen) {
                element.requestFullscreen()
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen()
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen()
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen()
            }
            this.fullscreenId = animationId
        },
        exitFullscreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen()
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen()
            }
            this.fullscreenId = null
        },
        handleFullscreenChange() {
            if (!document.fullscreenElement &&
                !document.webkitFullscreenElement &&
                !document.mozFullScreenElement &&
                !document.msFullscreenElement) {
                this.fullscreenId = null
            }
        },

        setAnimationTimeout(animationId) {
            if (this.animationTimeouts[animationId]) {
                clearTimeout(this.animationTimeouts[animationId])
            }
            this.animationTimeouts[animationId] = setTimeout(() => {
                if (this.animationLoading[animationId]) {
                    console.warn(`动画课件 ${animationId} 加载超时`)
                    this.onAnimationError(animationId, '加载超时，请检查网络或文件路径')
                }
            }, 15000)
        },
        onAnimationLoad(animationId) {
            console.log(`动画课件 ${animationId} 加载成功`)
            if (this.animationTimeouts[animationId]) {
                clearTimeout(this.animationTimeouts[animationId])
            }
            this.animationLoading[animationId] = false
        },
        onAnimationError(animationId, customMessage) {
            console.error(`动画课件 ${animationId} 加载失败`)
            if (this.animationTimeouts[animationId]) {
                clearTimeout(this.animationTimeouts[animationId])
            }
            this.animationLoading[animationId] = false
            this.animationErrorMsg = customMessage || `动画课件${animationId}加载失败，请检查网络连接或文件路径`
            this.failedAnimationId = animationId
            this.animationErrorDialogVisible = true
        },
        retryLoadAnimation() {
            if (this.failedAnimationId) {
                this.animationLoading[this.failedAnimationId] = true
                this.setAnimationTimeout(this.failedAnimationId)
                const iframe = document.querySelector(`iframe[title*="动画课件${this.failedAnimationId}"]`)
                if (iframe) {
                    const currentSrc = iframe.src
                    iframe.src = ''
                    setTimeout(() => {
                        iframe.src = currentSrc
                    }, 100)
                }
                this.animationErrorDialogVisible = false
            }
        },

        eleToView(id) {
            let ele = document.querySelector("#" + id)
            if (!ele) return
            ele.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            this.eleId = id;
        },
        highlightNav() {
            const navItems = document.querySelectorAll('.view-item');
            navItems.forEach(item => {
                const targetId = item.getAttribute('data-target');
                const targetElement = document.getElementById(targetId);
                if (this.isElementInViewport(targetElement)) {
                    navItems.forEach((nav) => {
                        nav.classList.remove('active')
                    })
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
            });
        },
        isElementInViewport(el) {
            if (!el) return
            const rect = el.getBoundingClientRect();
            if (el.id === 'history-section') {
                return (rect.top <= 400)
            }
            return (rect.top <= 100 && rect.bottom >= 240);
        },

        async openPrivatePolicy() {
            const newWindow = window.open('', '_blank');
            let res = await getPrivatePolicy();
            if (!res && !res.data) return
            newWindow.document.write(res.data);
            newWindow.document.close();
        },
        async openServiceItem() {
            const newWindow = window.open('', '_blank');
            let res = await getServiceItems();
            if (!res) return
            newWindow.document.write(res.data);
            newWindow.document.close();
        },

        toggleAndroidGuide() {
            this.showAndroidGuide = !this.showAndroidGuide;
        }
    },
    beforeDestroy() {
        Object.values(this.animationTimeouts).forEach(timeoutId => {
            if (timeoutId) clearTimeout(timeoutId)
        })
        document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
        document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
        document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange)
        document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange)
    }
}
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

a {
    text-decoration: none;
    color: #2e5bff;
}

.gradient-text {
    background: linear-gradient(135deg, #2e5bff, #a855f7);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    display: inline-block;
}

.photo-svg-wrapper {
    margin: 16px auto 0;
    text-align: center;
    background: #f5f7fa;
    border-radius: 20px;
    padding: 16px 0;
    width: fit-content;
    max-width: 90%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    img {
        width: 95%;
        height: auto;
        display: inline-block;
        border-radius: 12px;
    }
}

.download-wrap {
    height: 100vh;
    overflow-y: scroll;
    background: linear-gradient(180deg, #ecedee, #fff 51%, #fff 100%, #f1f1f1 0);
    &::-webkit-scrollbar-thumb {
        background: rgba(46, 91, 255, 0.3);
        border-radius: 4px;
        &:hover {
            background: #2e5bff;
        }
    }
    .navigation-section {
        display: flex;
        align-items: center;
        height: 0;
        justify-content: center;
        position: sticky;
        top: 72px;
        width: 100%;
        z-index: 9;

        .navigation {
            display: flex;
            align-items: center;
            backdrop-filter: blur(15px);
            background: linear-gradient(132deg, rgba(235, 237, 240, .85) 9.65%, rgba(233, 236, 238, .81) 58.96%, rgba(254, 254, 255, .87) 86.15%);
            border: 1px solid #fff;
            border-radius: 100px;
            box-shadow: 0 20px 30px 0 rgba(77, 90, 108, .12);
            gap: 60px;
            height: 60px;
            padding: 0 20px 0 8px;

            .icon-name {
                align-items: center;
                display: flex;
                gap: 12px;
                .icon {
                    aspect-ratio: 1 / 1;
                    border-radius: 50%;
                    flex-shrink: 0;
                    vertical-align: bottom;
                    width: 36px;
                    background-image: url('/logo.png');
                    background-size: 80% 80%;
                    background-repeat: no-repeat;
                    background-position: center;
                }
                .name {
                    color: var(--txt-default-color);
                    font-size: 22px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 700;
                    min-width: 36px;
                }
            }

            .view-list {
                align-items: center;
                display: flex;
                gap: 20px;
                .view-item {
                    color: var(--Text---s-color-text-tertiary, rgba(0, 0, 0, .4));
                    cursor: pointer;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    &:hover {
                        color: var(--Text---s-color-text-secondary, rgba(0, 0, 0, .7));
                    }
                    &.active {
                        color: #2e5bff;
                        font-weight: 600;
                    }
                }
            }
        }
    }

    .slogan-section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .slogan-wrap {
            font-size: 48px;
            margin-top: 150px;
            font-weight: 700;
            line-height: 130%;
            text-align: center;
            .slogan {
                padding: 0 32px;
                background: linear-gradient(135deg, #2e5bff, #a855f7);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
            }
        }

        .link-wrap {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 24px auto 13px;
            padding: 0 28px;
            height: 48px;
            border-radius: 60px;
            background: #fff;
            border: 1.5px solid #d0deff;
            color: #2e5bff;
            cursor: pointer;
            transition: all 0.3s ease;
            gap: 6px;
            p {
                font-size: 18px;
                margin-right: 2px;
                font-weight: 700;
                color: #2e5bff;
            }
            svg {
                display: block;
                width: 16px;
                vertical-align: middle;
                color: #2e5bff;
            }
            &:hover {
                border-color: #2e5bff;
                transform: translateY(-4px);
                box-shadow: 0 12px 28px rgba(46, 91, 255, 0.12);
            }
        }

        // ===== 下载卡片（对标 feature-card） =====
        .download-cards {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
            margin: 30px 20px 10px;
            max-width: 1200px;
            width: 100%;

            .cards-grid {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 30px;
                width: 100%;

                .card-item {
                    background: linear-gradient(135deg, #f8faff 0%, #eef3ff 100%);
                    border-radius: 28px;
                    padding: 28px 24px 24px;
                    flex: 1 1 200px;
                    min-width: 200px;
                    max-width: 280px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    box-shadow: 0 8px 32px rgba(46, 91, 255, 0.06);
                    border: 1px solid #edf2ff;
                    position: relative;
                    overflow: hidden;
                    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

                    // 顶部装饰光条（对标 feature-card）
                    &::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 4px;
                        background: linear-gradient(90deg, #2e5bff, #a855f7, #f472b6);
                        opacity: 0;
                        transition: opacity 0.4s ease;
                    }

                    &:hover,
                    &.active {
                        background: linear-gradient(135deg, #eef3ff 0%, #dfe9ff 100%);
                        transform: translateY(-8px);
                        box-shadow: 0 20px 48px rgba(46, 91, 255, 0.12);
                        border-color: #c8d9ff;

                        &::before {
                            opacity: 1;
                        }

                        .card-title {
                            display: inline-block;
                            background: linear-gradient(135deg, #2e5bff, #7c3aed);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                            background-clip: text;
                        }

                        .download-btn.small-btn {
                            transform: scale(1.02);
                            box-shadow: 0 8px 24px rgba(46, 91, 255, 0.3);
                        }
                    }

                    .card-icon {
                        font-size: 44px;
                        line-height: 1.2;
                        margin-bottom: 12px;
                    }

                    .card-body {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: 100%;
                        .card-title {
                            font-size: 20px;
                            font-weight: 700;
                            color: #0f1a2e;
                            margin-bottom: 6px;
                            transition: all 0.4s ease;
                        }
                        .card-desc {
                            font-size: 14px;
                            color: #4b5e7a;
                            line-height: 1.5;
                            margin-bottom: 16px;
                        }

                        .android-qr-center {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            gap: 4px;
                            margin: 4px 0 12px 0;
                            .qr-img-mid {
                                width: 88px;
                                height: 88px;
                                border-radius: 12px;
                                background: #fff;
                                padding: 6px;
                                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
                                transition: transform 0.2s;
                                &:hover {
                                    transform: scale(1.05);
                                }
                            }
                            .qr-tip {
                                font-size: 13px;
                                color: rgba(0, 0, 0, 0.5);
                                font-weight: 500;
                                letter-spacing: 0.3px;
                            }
                        }
                    }

                    .download-link {
                        width: 100%;
                        margin-top: auto;
                        .download-btn.small-btn {
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            background: linear-gradient(135deg, #2e5bff, #7c3aed);
                            color: #fff;
                            border-radius: 60px;
                            padding: 10px 20px;
                            font-size: 16px;
                            font-weight: 600;
                            transition: all 0.3s ease;
                            width: 100%;
                            span {
                                line-height: 1.2;
                            }
                            &:hover {
                                transform: scale(1.02);
                                box-shadow: 0 8px 24px rgba(46, 91, 255, 0.3);
                            }
                        }
                    }
                }
            }
        }

        // ===== 安卓安装指南 =====
        .android-guide-wrapper {
            margin-top: 20px;
            width: 90%;
            max-width: 600px;
        }

        .android-guide {
            background: linear-gradient(135deg, #f8faff 0%, #eef3ff 100%);
            border-radius: 20px;
            box-shadow: 0 8px 32px rgba(46, 91, 255, 0.06);
            border: 1px solid #edf2ff;
            overflow: hidden;
            transition: all 0.3s ease;

            &:hover {
                box-shadow: 0 12px 40px rgba(46, 91, 255, 0.10);
                border-color: #c8d9ff;
            }

            .guide-toggle {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 14px 20px;
                cursor: pointer;
                font-size: 16px;
                font-weight: 600;
                color: #0f1a2e;
                transition: background 0.2s;
                user-select: none;
                background: rgba(255, 255, 255, 0.4);
                &:hover {
                    background: rgba(46, 91, 255, 0.06);
                }
                .el-icon-arrow-down {
                    margin-left: 8px;
                    transition: transform 0.3s ease;
                    &.rotated {
                        transform: rotate(180deg);
                    }
                }
            }

            .guide-content {
                padding: 20px 24px 24px;
                background: #fff;
                border-top: 1px solid #edf2ff;
                ol {
                    margin: 0 0 12px 0;
                    padding-left: 20px;
                    li {
                        margin-bottom: 8px;
                        font-size: 14px;
                        line-height: 1.6;
                        color: #4b5e7a;
                    }
                    code {
                        background: #eef3ff;
                        padding: 2px 8px;
                        border-radius: 4px;
                        font-size: 13px;
                        color: #2e5bff;
                    }
                }
                .guide-note {
                    margin: 8px 0 0;
                    font-size: 14px;
                    color: #4b5e7a;
                    padding: 8px 12px;
                    background: #f8faff;
                    border-radius: 8px;
                    border-left: 4px solid #2e5bff;
                }
            }
        }

        .img-wrap {
            margin-top: 0px;
            .img {
                aspect-ratio: 1269 / 1317;
                width: 1200px;
                background: url('../assets/image/introduce/home.svg') no-repeat;
                background-position: center;
                background-size: contain;
                border-radius: 40px;
            }
        }
    }

    // ===== 组卷智能体卡片（左右布局） =====
    .card-section {
        padding-top: 100px;
        padding-bottom: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
            font-size: 46px;
            font-weight: 700;
            line-height: 110%;
            text-align: center;
        }
        .desc {
            margin-top: 16px;
            font-size: 20px;
            text-align: center;
            font-weight: 400;
            line-height: 120%;
            color: #4b5e7a;
            white-space: pre-wrap;
        }

        .narrow-detail-list {
            display: none;
        }

        .wide-detail-list {
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: 60px;
            margin-top: 73px;
            max-width: 1264px;

            .card {
                padding: 0 72px;
                display: flex;
                align-items: center;
                width: 100%;
                height: 636px;
                gap: 60px;
                border: 1px solid #ececec;
                border-radius: 48px;
                box-shadow: inset 0 0 3px 0 hsla(0, 0%, 100%, .1), 0 24px 32px 0 transparent;
                background: linear-gradient(0deg, hsla(0, 0%, 100%, .2), hsla(0, 0%, 100%, .2)), linear-gradient(285deg, #f8f3ee -3.93%, #fff 50.17%, #ebf0f6 103.2%);
                transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
                position: relative;
                overflow: hidden;

                // 左侧装饰光条
                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    width: 4px;
                    background: linear-gradient(180deg, #2e5bff, #a855f7, #f472b6);
                    opacity: 0;
                    transition: opacity 0.4s ease;
                    border-radius: 4px 0 0 4px;
                }

                &:hover {
                    transform: translateY(-6px);
                    box-shadow: 0 20px 48px rgba(46, 91, 255, 0.10);
                    border-color: #c8d9ff;

                    &::before {
                        opacity: 1;
                    }

                    .card-left .card-title {
                        background: linear-gradient(135deg, #2e5bff, #7c3aed);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        background-clip: text;
                    }

                    .card-img {
                        transform: scale(1.02);
                    }
                }

                img {
                    height: 400px;
                    width: 580px;
                    border-radius: 14px;
                    flex-shrink: 0;
                    max-width: 100%;
                    vertical-align: bottom;
                    transition: transform 0.4s ease;
                }

                .card-left {
                    width: 50%;
                    gap: 16px;
                    display: flex;
                    flex-direction: column;
                    .card-title {
                        font-size: 46px;
                        line-height: 1.2;
                        white-space: pre-wrap;
                        color: var(--txt-default-color);
                        font-style: normal;
                        font-weight: 600;
                        white-space: pre-wrap;
                        transition: all 0.4s ease;
                    }
                    .card-desc {
                        color: var(--txt-desc-color, rgba(0, 0, 0, .7));
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                    }
                }
            }
        }
    }

    // ===== Introduce 模块（图片卡片） =====
    .introduce-section {
        padding-top: 100px;
        padding-bottom: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
            font-size: 46px;
            font-weight: 700;
            line-height: 110%;
            text-align: center;
        }
        .desc {
            margin-top: 16px;
            font-size: 20px;
            text-align: center;
            font-weight: 400;
            line-height: 120%;
            color: #4b5e7a;
        }
        .img-wrap {
            margin-top: 73px;
            width: 1200px;
            aspect-ratio: 2 / 1;
            overflow: hidden;
            border-radius: 48px;
            background-position: 45% 50%;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            box-shadow: 0 8px 32px rgba(46, 91, 255, 0.06);
            border: 1px solid #edf2ff;
            transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

            // 模仿卡片顶部光条
            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 4px;
                background: linear-gradient(90deg, #2e5bff, #a855f7, #f472b6);
                opacity: 0;
                transition: opacity 0.4s ease;
                border-radius: 48px 48px 0 0;
            }

            &:hover {
                transform: translateY(-6px);
                box-shadow: 0 16px 40px rgba(46, 91, 255, 0.12);
                border-color: #c8d9ff;

                &::before {
                    opacity: 1;
                }
            }

            // 部分图片容器可能没有伪元素位置，需要相对定位
            position: relative;
        }
    }

    .desktop_donghua {
        .img-wrap {
            display: none;
        }
    }

    // ===== 动画课件 =====
    .animation-container {
        display: flex;
        gap: 40px;
        justify-content: center;
        margin-top: 60px;
        width: 100%;
        max-width: 1200px;
        padding: 0 20px;
        &.vertical {
            flex-direction: column;
            align-items: center;
        }
    }

    .animation-item {
        width: 100%;
        max-width: 1000px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        margin-bottom: 30px;

        .animation-frame-wrapper {
            position: relative;
            width: 100%;
            height: 600px;
            border-radius: 28px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(46, 91, 255, 0.06);
            background: #f8faff;
            border: 1px solid #edf2ff;
            transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

            // 顶部光条
            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 4px;
                background: linear-gradient(90deg, #2e5bff, #a855f7, #f472b6);
                opacity: 0;
                transition: opacity 0.4s ease;
                z-index: 5;
                border-radius: 28px 28px 0 0;
            }

            &:hover {
                transform: translateY(-6px);
                box-shadow: 0 16px 40px rgba(46, 91, 255, 0.12);
                border-color: #c8d9ff;

                &::before {
                    opacity: 1;
                }
            }
        }

        .animation-frame {
            width: 100%;
            height: 100%;
            border: none;
        }

        .fullscreen-controls {
            position: absolute;
            top: 15px;
            right: 15px;
            display: flex;
            gap: 8px;
            z-index: 10;
        }

        .fullscreen-btn {
            background: rgba(46, 91, 255, 0.9);
            border: none;
            border-radius: 20px;
            color: white;
            cursor: pointer;
            padding: 8px 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            font-size: 14px;
            font-weight: 500;
            transition: all 0.3s ease;
            box-shadow: 0 2px 8px rgba(46, 91, 255, 0.3);
            &:hover {
                background: #2e5bff;
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(46, 91, 255, 0.4);
            }
            &:active {
                transform: translateY(0);
            }
            svg {
                width: 16px;
                height: 16px;
            }
            .fullscreen-text {
                margin-left: 2px;
            }
        }

        .animation-loading {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 600px;
            border-radius: 28px;
            background: linear-gradient(135deg, #f8faff 0%, #eef3ff 100%);
            box-shadow: 0 8px 32px rgba(46, 91, 255, 0.06);
            border: 1px solid #edf2ff;
            .loading-spinner {
                width: 50px;
                height: 50px;
                border: 3px solid #eef3ff;
                border-top: 3px solid #2e5bff;
                border-radius: 50%;
                animation: spin 1s linear infinite;
                margin-bottom: 20px;
            }
            p {
                color: #4b5e7a;
                font-size: 16px;
            }
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        }

        .animation-title {
            font-size: 20px;
            font-weight: 600;
            color: #0f1a2e;
            text-align: center;
            padding: 0 10px;
            margin-top: 10px;
        }
    }

    // ===== 各模块图片背景 =====
    .desktop_jiaocai {
        .img-wrap {
            background-size: 100% 1200;
            &.first { background-image: url('../assets/image/introduce/jiaocai.png'); }
            &.second { background-image: url('../assets/image/introduce/jiaocai1.png'); }
            &.three { background-image: url('../assets/image/introduce/jiaocai2.png'); }
        }
    }

    .desktop_tupu {
        .img-wrap {
            background-size: 100% 100%;
            &.first { background-image: url('../assets/image/introduce/tupu.png'); }
            &.second { background-image: url('../assets/image/introduce/tupu1.png'); }
        }
    }

    .desktop_topic {
        .img-wrap {
            &.first { aspect-ratio: 1359 / 1182; background-image: url('../assets/image/introduce/topic.png'); }
            &.second { aspect-ratio: 1277 / 1131; background-image: url('../assets/image/introduce/topic1.png'); }
            &.three { aspect-ratio: 1277 / 800; background-image: url('../assets/image/introduce/topic2.png'); }
        }
    }

    .desktop_photo {
        .img-wrap {
            aspect-ratio: 1341 / 922;
            &.first { background-image: url('../assets/image/introduce/photo.png'); }
        }
    }

    .desktop_recommand {
        .img-wrap {
            &.first { aspect-ratio: 1416 / 1092; background-image: url('../assets/image/introduce/recommad.png'); }
        }
    }

    .desktop_zhenduan {
        .img-wrap {
            &.first { aspect-ratio: 1416 / 1092; background-image: url('../assets/image/introduce/zhenduan.png'); }
        }
    }

    .desktop_draw {
        .img-wrap {
            &.first { aspect-ratio: 1458 / 1208; background-image: url(../assets/image/introduce/draw.png); }
            &.second { aspect-ratio: 1448 / 1311; background-image: url(../assets/image/introduce/draw1.png); }
        }
    }

    // ===== 底部标语 =====
    .slogan-wrap {
        font-size: 46px;
        font-weight: 700;
        text-align: center;
        .slogan {
            background: linear-gradient(135deg, #2e5bff, #a855f7);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
    }

    // ===== 底部版权 =====
    .bottom-section {
        margin-top: 101px;

        .copyright-wrap {
            padding-left: 60px;
            padding-right: 60px;
            width: calc(100vw - 20px);
            align-items: center;
            border-top: 0.4px solid rgba(0, 0, 0, .2);
            display: flex;
            height: auto;
            min-height: 100px;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 20px;

            .copyright {
                display: flex;
                flex-wrap: wrap;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px;
                color: var(--s-color-text-tertiary, rgba(0, 0, 0, .55));
                .registration-link {
                    font-size: 13px;
                    line-height: 20px;
                    margin-right: 10px;
                    &:hover {
                        color: #2e5bff;
                        cursor: pointer;
                    }
                }
            }

            .contact-area {
                display: flex;
                align-items: center;
                gap: 32px;
                flex-shrink: 0;

                .contact-links-vertical {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    align-items: flex-start;
                    .link-item {
                        color: var(--txt-default-color);
                        font-size: 13px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 16px;
                        padding: 4px 0;
                        white-space: nowrap;
                        cursor: pointer;
                        transition: color 0.2s;
                        &:hover {
                            color: #2e5bff;
                        }
                        &.contact-email {
                            cursor: default;
                            &:hover {
                                color: var(--txt-default-color);
                            }
                        }
                    }
                }

                .qr-code-block {
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 6px;
                    .qr-code-large {
                        width: 90px;
                        height: 90px;
                        display: block;
                        border-radius: 12px;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                        transition: transform 0.2s;
                        &:hover {
                            transform: scale(1.02);
                        }
                    }
                    .qr-tip-text {
                        font-size: 12px;
                        color: rgba(0, 0, 0, 0.55);
                        line-height: 1;
                    }
                }
            }
        }
    }

    // ===== 下载表格 =====
    .history-section {
        margin: 100px 8%;
        display: flex;
        justify-content: center;
        ::v-deep .el-table {
            width: 100%;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 4px 16px rgba(0,0,0,0.06);
            th {
                background: #f8faff;
                font-weight: 600;
                color: #0f1a2e;
            }
            td {
                color: #4b5e7a;
            }
            a {
                color: #2e5bff;
                font-weight: 500;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}

// ============================================================
// 响应式
// ============================================================

@media screen and (min-width: 1120px) and (max-width: 1300px) {
    .download-wrap {
        .introduce-section .img-wrap { width: 85%; }
        .card-section .wide-detail-list { padding-left: 40px; padding-right: 40px; }
        .slogan-section .img-wrap { width: 80%; .img { width: 100%; } }
        .animation-container { max-width: 1000px; padding: 0 40px; &.vertical .animation-item { max-width: 900px; } }
        .bottom-section .copyright-wrap .contact-area .qr-code-block .qr-code-large { width: 80px; height: 80px; }
    }
}

@media screen and (min-width: 800px) and (max-width: 1120px) {
    .download-wrap {
        .navigation-section .navigation { gap: 28px; }
        .slogan-section .link-wrap svg { width: 16px; }
        .slogan-section .img-wrap { width: 80%; .img { width: 100%; height: auto; } }
        .card-section .wide-detail-list { height: auto; padding: 40px 40px; .card { padding: 52px 40px; display: flex; align-items: center; width: 100%; img { height: auto; width: 400px; flex-shrink: 0; } .card-left .card-title { font-size: 30px; } .card-left .card-desc { font-size: 14px; } } }
        .introduce-section .img-wrap { width: 80%; }
        .animation-container { max-width: 900px; gap: 30px; padding: 0 30px; &.vertical .animation-item { max-width: 800px; .animation-frame-wrapper { height: 500px; } .animation-loading { height: 500px; } .fullscreen-btn { padding: 6px 12px; font-size: 13px; svg { width: 14px; height: 14px; } } } }
        .bottom-section .copyright-wrap .contact-area { gap: 24px; .qr-code-block .qr-code-large { width: 80px; height: 80px; } }
        .slogan-section .download-cards .cards-grid .card-item { max-width: 240px; }
    }
}

@media (max-width: 1048px) {
    .download-wrap {
        .navigation-section .navigation { gap: 20px; }
        .card-section .desc { padding: 0 20px; }
        .introduce-section .desc { padding: 0 40px; }
        .bottom-section .copyright-wrap { padding-left: 30px; padding-right: 30px; flex-direction: column; align-items: flex-start; .contact-area { width: 100%; justify-content: space-between; } }
    }
}

@media (max-width: 799px) {
    .download-wrap {
        .navigation-section { display: none !important; position: relative; }
        .slogan-section {
            .slogan { font-size: 40px !important; }
            .link-wrap svg { width: 16px; }
            .img-wrap { width: 80%; .img { width: 100%; height: auto; } }
            .download-cards {
                .cards-grid {
                    flex-direction: column;
                    align-items: center;
                    .card-item {
                        max-width: 300px;
                        width: 100%;
                        padding: 16px 12px;        // 减小内边距，节省空间
                        overflow: visible;         // 确保内容不被裁剪
                        .card-body {
                            .android-qr-center {
                                .qr-img-mid {
                                    width: 88px;    // 缩小二维码尺寸
                                    height: 88px;
                                    padding: 4px;
                                }
                                .qr-tip {
                                    font-size: 11px; // 缩小提示文字
                                }
                            }
                        }
                    }
                }
            }
        }
        .slogan-wrap { font-size: 24px; }
        .link-wrap svg { width: 16px !important; }
        .card-section {
            .title { font-size: 30px; }
            .desc { font-size: 14px; }
            .wide-detail-list { display: none !important; }
            .narrow-detail-list {
                display: flex;
                align-items: center;
                flex-direction: column;
                gap: 40px;
                margin-top: 40px;
                padding: 0 20px;
                width: 100%;
                .card {
                    flex-direction: column;
                    padding: 0 72px;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    border-radius: 20px;
                    box-shadow: 24px 32px 0 #00000000, inset 0 0 .04688rem 0 #ffffff1a;
                    background: linear-gradient(0deg, hsla(0, 0%, 100%, .2), hsla(0, 0%, 100%, .2)), linear-gradient(285deg, #f8f3ee -3.93%, #fff 50.17%, #ebf0f6 103.2%);
                    padding: 30px;
                    width: 100%;
                    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
                    border: 1px solid #ececec;
                    border-radius: 28px;
                    position: relative;
                    overflow: hidden;

                    &::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 4px;
                        background: linear-gradient(90deg, #2e5bff, #a855f7, #f472b6);
                        opacity: 0;
                        transition: opacity 0.4s ease;
                    }

                    &:hover {
                        transform: translateY(-6px);
                        box-shadow: 0 20px 48px rgba(46, 91, 255, 0.10);
                        border-color: #c8d9ff;
                        &::before { opacity: 1; }
                        .card-title {
                            background: linear-gradient(135deg, #2e5bff, #7c3aed);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                            background-clip: text;
                        }
                        img { transform: scale(1.02); }
                    }

                    img { margin-top: 47px; height: auto; width: 100%; border-radius: 14px; max-width: 100%; transition: transform 0.4s ease; }
                    .card-title { font-size: 24px; transition: all 0.4s ease; }
                    .card-desc { margin-top: 10px; font-size: 14px; }
                }
            }
        }
        .introduce-section {
            .title { font-size: 30px; font-weight: 700; line-height: 110%; text-align: center; }
            .desc { margin-top: 16px; font-size: 14px; text-align: center; font-weight: 400; line-height: 120%; }
            .img-wrap { margin-top: 73px; width: 90%; border-radius: 30px; }
        }
        .animation-container {
            flex-direction: column;
            gap: 30px;
            padding: 0 15px;
            &.vertical .animation-item {
                width: 100%;
                max-width: 100%;
                .animation-frame-wrapper { height: 350px; }
                .animation-loading { height: 350px; .loading-spinner { width: 40px; height: 40px; } p { font-size: 14px; } }
                .fullscreen-btn { padding: 5px 10px; font-size: 12px; svg { width: 12px; height: 12px; } .fullscreen-text { display: none; } }
                .animation-title { font-size: 16px; }
            }
        }
        .bottom-section .copyright-wrap {
            padding: 20px 20px;
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: 16px;
            .copyright { justify-content: center; .registration-link { width: auto; margin: 0 8px; } }
            .contact-area {
                flex-direction: column;
                align-items: center;
                gap: 20px;
                .contact-links-vertical { align-items: center; gap: 12px; .link-item { white-space: nowrap; } }
                .qr-code-block { .qr-code-large { width: 100px; height: 100px; } .qr-tip-text { font-size: 11px; } }
            }
        }
        .history-section {
            margin: 60px 4%;
            ::v-deep .el-table {
                font-size: 12px;
                .el-table__header th {
                    padding: 8px 4px;
                }
                .el-table__body td {
                    padding: 6px 4px;
                }
            }
        }
        .android-guide-wrapper {
            width: 95%;
        }
    }
}
</style>